// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"1ba41ea8","453":"92406337","548":"937ffc75"}[chunkId] + ".chunk.js";
};